<div class="account-switcher" *ngIf="showBaoying">
    <div *ngIf="authenticated">
        <span class="account-name fw-bold">{{recognitionName}}</span>&nbsp;
        <span class="account-name">({{customerId}})</span>
        <a class="navLink" (click)="switchAccounts()" translate="cart.switch.accounts"></a>
    </div>
    <a *ngIf="!authenticated" class="navLink" (click)="login()" translate="cart.login"></a>
</div>
